import { ImageEntry } from '../../content.types';

export const images: Record<string, ImageEntry> = {};
